'use strict'

const STALE_THRESHOLD_MS = 10 * 60 * 1000 // 10 minutes

function isFresh(op) {
  return (Date.now() - op.startedAt) < STALE_THRESHOLD_MS
}

const state = {
  pendingOperations: [],
}

const getters = {
  shipSecurePendingOperations: (state) => state.pendingOperations.filter(isFresh),

  shipSecureOperationsPendingForEntity: (_state, getters) => (entityType, entityId) => {
    return getters.shipSecurePendingOperations.filter(
      op => op.entityType === entityType && op.entityId === entityId
    )
  },
}

const mutations = {
  ADD_SHIPSECURE_PENDING_OPERATION(state, operation) {
    state.pendingOperations = [
      ...state.pendingOperations.filter(isFresh),
      {
        ...operation,
        startedAt: Date.now(),
      },
    ]
  },

  REMOVE_SHIPSECURE_PENDING_OPERATION(state, operationId) {
    state.pendingOperations = state.pendingOperations.filter(op => op.id !== operationId)
  },
}

export default {
  state,
  getters,
  mutations,
}
